import React from "react";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import { useHistory } from "react-router-dom";

import Action from "../Common/Action";

const SelectAllocationTypeRow = ({ buttonText, imgSrc, route, dataCy }: { buttonText: string, imgSrc: string, route: string, dataCy: string }) => {
  const history = useHistory();

  return (
    <article className="select-allocation-type-row">
      <div>
        <Action
          displayType={ACTION_DISPLAY_TYPES.PRIMARY}
          onClick={() => history.push(route)}
          title={buttonText}
          dataCy={dataCy}
        />
      </div>

      <figure>
        <img src={imgSrc} alt={buttonText} />
      </figure>
    </article>
  );
}

export default SelectAllocationTypeRow;